<template>
    <div class="submain">
        <h1>知识库</h1>
        <el-form ref="form" :inline="true" :model="formInvoice" label-width="100px">
            <el-form-item label="申请时间：">
                <el-date-picker type="date" placeholder="选择日期" v-model="formInvoice.date3" style="width: 100%;"></el-date-picker>
              </el-form-item>
            <el-form-item label="实际完成时间：">
              <el-date-picker type="date" placeholder="选择日期" v-model="formInvoice.date3" style="width: 100%;"></el-date-picker>
            </el-form-item>
            <el-form-item label="主题：">
                <el-input v-model="formInvoice.zt"></el-input>
            </el-form-item>
            <el-form-item label="质量工程师：">
              <el-input v-model="formInvoice.wtbm"></el-input>
            </el-form-item>
            <el-form-item style="width: 100%;text-align: right;">
              <el-button type="primary" @click="onSubmit">查询</el-button>
              <!-- <el-button>重置</el-button> -->
            </el-form-item>
        </el-form>
        <div class="table">
            <el-table
            stripe
                :data="tabledata"
                border
                style="width: 100%">
                <el-table-column
                prop="num"
                label="序号"
                width="50">
                </el-table-column>
                <el-table-column
                prop="name"
                label="产品分类"
                width="180">
                </el-table-column>
                <el-table-column
                prop="address"
                label="品种">
                </el-table-column>
                <el-table-column
                prop="num"
                label="规格"
                width="180">
                </el-table-column>
                <el-table-column
                prop="name"
                label="形式"
                width="180">
                </el-table-column>
                <el-table-column
                prop="address"
                label="data shee">
                </el-table-column>
                <el-table-column
                prop="num"
                label="样本资料"
                width="180">
                </el-table-column>
                <el-table-column
                prop="name"
                label="认证资料"
                width="180">
                </el-table-column>
                <el-table-column
                prop="address"
                label="产品宣传资料">
                </el-table-column>
                <el-table-column
                prop="num"
                label="产品标准资料"
                width="180">
                </el-table-column>
                <el-table-column
                prop="name"
                label="上传附件"
                width="180">
                <el-upload
                class="upload-demo"
                action="https://jsonplaceholder.typicode.com/posts/"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                multiple
                :limit="3"
                :on-exceed="handleExceed"
                :file-list="fileList"
                >
                <el-button type="primary" icon="el-icon-upload"></el-button>
                </el-upload>
                </el-table-column>
                <el-table-column
                prop="name"
                label="查看"
                width="180">
                <el-button type="text">查看</el-button>
                </el-table-column>
                <el-table-column
                prop="name"
                label="下载"
                width="180">
                <el-button type="primary" icon="el-icon-download"></el-button>
                </el-table-column>
            </el-table>
        </div>
        <div class="pages">
            <el-pagination @current-change="handleCurrentChange"
        v-model:currentPage="currentPage" :page-size="100" :total="1000" 
        layout="prev, pager, next, jumper" background></el-pagination>
        </div>
    </div>
</template>

<script>
    import { ref } from 'vue'

    export default {
        name: 'KnowledgeBase',
        setup() {
            let formInvoice = ref({
                date1: '',
                date2: '',
                date3: '',
                wtbm: '',
                zzr: '',
                wtzt: '',
                zt: '',
            })
            let onSubmit = () => {}
            let tabledata = ref([])
            // 翻页
            let currentPage = ref(1)
            let handleCurrentChange = () => {}
            return {
                tabledata,
                onSubmit,
                currentPage,
                handleCurrentChange,
                formInvoice,
            }
        }
    }
</script>

<style scoped lang="scss">
    .submain {
        padding: 10px;
        padding-bottom: 20px;
        background: #fff;
        h1 {
            font-size: 16px;
            padding: 10px 0;
            border-bottom: 1px solid rgba(223, 223, 223, 1);
            margin-bottom: 20px;
        }
        ::v-deep(.el-input__inner) {
            height: 30px;
            width: 150px;
        }
        ::v-deep(.el-col-11) {
            max-width: 50%;
        }
        ::v-deep(.el-button) {
            height: 30px;
        }
        .table {
            margin-top: 20px;
        }
        .pages {
            margin-top: 30px;
            ::v-deep(.el-input__inner) {
                height: 25px;
                width: 40px;
            }
            ::v-deep(.el-pagination.is-background .el-pager li:hover) {
                background: rgba(255, 0, 0, 1);
                color: #fff;
            }
        }
    }
</style>